/**
 * TanStack Query hooks for `custom-report-columns`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customReportColumnsQueryKeys,
	type CreateCustomReportColumnsBody,
	type ListCustomReportColumnsResponse,
	type CustomReportColumnsRow,
} from "./api";

export function useCustomReportColumnsList(): UseQueryResult<ListCustomReportColumnsResponse, Error> {
	return useQuery({
		queryKey: customReportColumnsQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomReportColumnsCreate(): UseMutationResult<CustomReportColumnsRow, Error, CreateCustomReportColumnsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customReportColumnsQueryKeys.all });
		},
	});
}

export function useCustomReportColumnsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customReportColumnsQueryKeys.all });
		},
	});
}
